const categoryEn = [
  'Legal Services',
  'Accounting',
  'Cross-border Trade Dispute Support (Legal Advice) Pilot Scheme (1-Hour Free Legal Consultation)',
  // 'Financial Services',
  // 'Business Services',
  // 'Banking',
  // 'Insurance',
  // 'Film Industry',
];

export default categoryEn;
